import { FunctionComponent } from "react";
import { AutoTableRow } from "../auto-table-row/auto-table-row";
import { DEFAULT_LOADING_ROWS } from "./auto-table-loading.constants";
import { IProps } from "./auto-table-loading.types";

const AutoTableLoading: FunctionComponent<IProps> = ({
    children,
    loadingRows = DEFAULT_LOADING_ROWS,
    withChevronColumn,
}) => (
    <>
        {Array(loadingRows)
            .fill(0)
            .map((_, index) => (
                <AutoTableRow
                    index={index}
                    withChevronColumn={withChevronColumn}
                    key={`loading-row-${index}`}
                    row={null}
                >
                    {children}
                </AutoTableRow>
            ))}
    </>
);

export { AutoTableLoading };
